import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncrementalityIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.72266,
			width: 4.78404,
			height: .885934,
			rx: .442967,
			fill: "#69B200"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.01367 6.28589C4.5955 7.43063 5.64349 8.19489 6.83984 8.19507C7.6098 8.19507 8.31746 7.87705 8.87988 7.34644L11.3818 11.4695C11.4532 11.5875 11.3685 11.739 11.2305 11.739H0.886719C0.747507 11.7388 0.663317 11.5854 0.737305 11.4675L4.01367 6.28589Z",
			fill: "#69B200"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-3-inside-1_9110_516",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M7.62695 4.35083L11.8711 11.1223C12.2202 11.6793 11.8195 12.4036 11.1621 12.4036H0.837891C0.173505 12.4036 -0.225559 11.6659 0.137695 11.1096L4.61426 4.25513V0.020752H7.62695V4.35083Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.62695 4.35083H6.56383V4.65646L6.72614 4.91543L7.62695 4.35083ZM11.8711 11.1223L10.9703 11.6869L10.9703 11.6869L11.8711 11.1223ZM0.137695 11.1096L-0.752414 10.5283L-0.752431 10.5283L0.137695 11.1096ZM4.61426 4.25513L5.50437 4.83644L5.67738 4.57153V4.25513H4.61426ZM4.61426 0.020752V-1.04237H3.55114V0.020752H4.61426ZM7.62695 0.020752H8.69007V-1.04237H7.62695V0.020752ZM7.62695 4.35083L6.72614 4.91543L10.9703 11.6869L11.8711 11.1223L12.7719 10.5577L8.52776 3.78623L7.62695 4.35083ZM11.8711 11.1223L10.9703 11.6869C10.8757 11.536 10.9837 11.3404 11.1621 11.3404V12.4036V13.4667C12.6553 13.4667 13.5647 11.8226 12.7719 10.5577L11.8711 11.1223ZM11.1621 12.4036V11.3404H0.837891V12.4036V13.4667H11.1621V12.4036ZM0.837891 12.4036V11.3404C1.01859 11.3404 1.12605 11.5405 1.02782 11.6909L0.137695 11.1096L-0.752431 10.5283C-1.57717 11.7912 -0.671582 13.4667 0.837891 13.4667V12.4036ZM0.137695 11.1096L1.02781 11.6909L5.50437 4.83644L4.61426 4.25513L3.72415 3.67381L-0.752414 10.5283L0.137695 11.1096ZM4.61426 4.25513H5.67738V0.020752H4.61426H3.55114V4.25513H4.61426ZM4.61426 0.020752V1.08387H7.62695V0.020752V-1.04237H4.61426V0.020752ZM7.62695 0.020752H6.56383V4.35083H7.62695H8.69007V0.020752H7.62695Z",
			fill: "#69B200",
			mask: "url(#path-3-inside-1_9110_516)"
		})
	]
});
export default SvgIncrementalityIcon;
